// Main entry — the production View. (No Container: ListRail is a pure
// View.) Sim wrappers live under ./sim and are never imported here.
export { ListRail } from "./ListRail";
export type { ListRailProps } from "./ListRail";
